/**
 * Hook that derives video configuration from the current project state.
 *
 * Returns { durationInFrames, fps, duration, width, height } needed
 * by Sequence, Player, and other components.
 *
 * Written from scratch for Steve.AI.
 */

import { useProject } from '../store/projectContext';
import { getTotalDuration } from '../utils/sceneCalculator';

export const useVideoConfig = () => {
  const project = useProject();
  const fps = project?.fps || 30;

  if (project && project.scenes && project.scenes.length > 0) {
    const totalDuration = getTotalDuration(project.scenes, fps);
    return {
      durationInFrames: totalDuration,
      fps,
      duration: totalDuration / fps,
      width: project.width || 800,
      height: project.height || 450,
    };
  }

  // Default config when no project loaded
  return { durationInFrames: 150, fps: 30, duration: 5, width: 800, height: 450 };
};

// Alias for backward compatibility
export const useUnsafeVideoConfig = useVideoConfig;
